import React from "react"
import AlertDropDown from "./AlertDropDown"
import { Outlet } from "react-router-dom"
const GlobalWrapper = () => {
  return (
    <>
      <AlertDropDown />
      <Outlet />
    </>
  )
}

export default GlobalWrapper
